import { Avatar } from '@chakra-ui/react';

const AccountAvatar = ({ formattedValue, size, isRA = false, isDisabled }) => {
    const bg = isRA ? 'white' : '#007BFF';
    const color = isRA ? '#007BFF' : 'white';
    const borderColor = isDisabled ? 'gray.500' : isRA ? '#007BFF' : null;
    return (
        <Avatar
            size={size}
            name={formattedValue}
            bg={isDisabled ? 'gray.700' : bg}
            color={isDisabled ? 'gray.500' : color}
            borderColor={borderColor}
            showBorder
            borderWidth="1px"
        />
    );
};

export { AccountAvatar };
